export const whichQuestions = [
  {
    questionNumber: 1,
    questionText: "Which project are you working on now?",
    choices: {
      A: "Please submit your draft today.",
      B: "The marketing one.",
      C: "It was approved last week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지금 어떤 프로젝트를 진행하고 계신가요?",
      choices: {
        A: "오늘 초안을 제출해 주세요.",
        B: "마케팅 프로젝트요.",
        C: "지난주에 승인되었어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 현재 진행 중인 프로젝트가 마케팅 프로젝트라고 직접적으로 답변하고 있습니다. A는 지시문이고, C는 과거에 일어난 일을 설명하고 있어 현재 진행 중인 프로젝트에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 2,
    questionText: "Which file did she upload to the server?",
    choices: {
      A: "Upload it by 5 p.m.",
      B: "The sales report.",
      C: "I sent her an email.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그녀가 서버에 어떤 파일을 업로드했나요?",
      choices: {
        A: "오후 5시까지 업로드하세요.",
        B: "판매 보고서요.",
        C: "그녀에게 이메일을 보냈어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 업로드된 파일이 판매 보고서라고 직접적으로 답변하고 있습니다. A는 지시문이고, C는 관련 없는 행동을 설명하고 있어 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 3,
    questionText: "Which department do you work in?",
    choices: {
      A: "The finance team.",
      B: "Please come to the meeting.",
      C: "My supervisor is helpful.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "어떤 부서에서 일하시나요?",
      choices: {
        A: "재무팀이요.",
        B: "회의에 와주세요.",
        C: "제 상사는 도움이 많이 됩니다.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 일하는 부서가 재무팀이라고 직접적으로 답변하고 있습니다. B는 지시문이고, C는 상사에 대한 설명으로 부서에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 4,
    questionText: "Which document did you print just now?",
    choices: {
      A: "That's my printer.",
      B: "The contract summary.",
      C: "Don't forget to log out.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "방금 어떤 문서를 인쇄하셨나요?",
      choices: {
        A: "그건 제 프린터예요.",
        B: "계약서 요약본이요.",
        C: "로그아웃하는 것을 잊지 마세요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 인쇄한 문서가 계약서 요약본이라고 직접적으로 답변하고 있습니다. A는 프린터에 대한 설명이고, C는 지시문으로 인쇄한 문서에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 5,
    questionText: "Which conference did they attend in Seoul?",
    choices: {
      A: "The AsiaTech Expo.",
      B: "Yes, it was very informative.",
      C: "Let's schedule another one.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그들이 서울에서 어떤 컨퍼런스에 참석했나요?",
      choices: {
        A: "아시아테크 엑스포요.",
        B: "네, 매우 유익했어요.",
        C: "다른 것도 일정을 잡아봅시다.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 참석한 컨퍼런스가 아시아테크 엑스포라고 직접적으로 답변하고 있습니다. B는 컨퍼런스의 성격에 대한 평가이고, C는 제안으로 참석한 컨퍼런스에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 6,
    questionText: "Which color do you prefer for the banner?",
    choices: {
      A: "I like the blue one.",
      B: "Please order more ink.",
      C: "The banners are upstairs.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "배너에 어떤 색상을 선호하시나요?",
      choices: {
        A: "파란색이 좋아요.",
        B: "잉크를 더 주문해 주세요.",
        C: "배너는 위층에 있어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 선호하는 색상이 파란색이라고 직접적으로 답변하고 있습니다. B는 지시문이고, C는 배너의 위치에 대한 설명으로 색상 선호도에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 7,
    questionText: "Which section should I read first?",
    choices: {
      A: "The conclusion part.",
      B: "I'll bring my notebook.",
      C: "That chapter was revised.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "어떤 섹션을 먼저 읽어야 할까요?",
      choices: {
        A: "결론 부분이요.",
        B: "제 노트북을 가져올게요.",
        C: "그 챕터는 수정되었어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 먼저 읽어야 할 섹션이 결론 부분이라고 직접적으로 답변하고 있습니다. B는 관련 없는 행동을 설명하고, C는 챕터의 상태에 대한 설명으로 먼저 읽어야 할 섹션에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 8,
    questionText: "Which delivery did you receive this morning?",
    choices: {
      A: "The boxes of stationery.",
      B: "The delivery guy was nice.",
      C: "Please send another copy.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 아침에 어떤 배송품을 받으셨나요?",
      choices: {
        A: "문구류 상자들이요.",
        B: "배송 기사님이 친절했어요.",
        C: "다른 사본을 보내주세요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 받은 배송품이 문구류 상자라고 직접적으로 답변하고 있습니다. B는 배송 기사에 대한 설명이고, C는 요청으로 받은 배송품에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 9,
    questionText: "Which software are we using for the demo?",
    choices: {
      A: "The new accounting tool.",
      B: "Let's test the projector.",
      C: "It's on the table.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "데모에 어떤 소프트웨어를 사용하고 있나요?",
      choices: {
        A: "새로운 회계 도구요.",
        B: "프로젝터를 테스트해 봅시다.",
        C: "그것은 테이블 위에 있어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 데모에 사용하는 소프트웨어가 새로운 회계 도구라고 직접적으로 답변하고 있습니다. B는 제안이고, C는 위치에 대한 설명으로 사용하는 소프트웨어에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 10,
    questionText: "Which floor is the HR office on?",
    choices: {
      A: "The third one.",
      B: "I spoke to the manager.",
      C: "We can go later.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "인사과 사무실은 몇 층에 있나요?",
      choices: {
        A: "3층이요.",
        B: "매니저와 이야기했어요.",
        C: "나중에 갈 수 있어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 인사과 사무실이 3층에 있다고 직접적으로 답변하고 있습니다. B는 관련 없는 행동을 설명하고, C는 제안으로 인사과 사무실의 위치에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 11,
    questionText: "Which folder contains the updated proposal?",
    choices: {
      A: "It was updated this morning.",
      B: "I shared it with the team.",
      C: "The blue one on the left shelf.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "어떤 폴더에 업데이트된 제안서가 들어있나요?",
      choices: {
        A: "오늘 아침에 업데이트되었어요.",
        B: "팀과 공유했어요.",
        C: "왼쪽 선반에 있는 파란색 폴더요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. C는 업데이트된 제안서가 들어있는 폴더가 왼쪽 선반에 있는 파란색 폴더라고 직접적으로 답변하고 있습니다. A는 시간에 대한 정보이고, B는 행동에 대한 설명으로 폴더에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 12,
    questionText: "Which team will present first at the meeting?",
    choices: {
      A: "They're in Conference Room B.",
      B: "The design team.",
      C: "Please let them know.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "어떤 팀이 회의에서 먼저 발표할 예정인가요?",
      choices: {
        A: "그들은 회의실 B에 있어요.",
        B: "디자인 팀이요.",
        C: "그들에게 알려주세요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 회의에서 먼저 발표할 팀이 디자인 팀이라고 직접적으로 답변하고 있습니다. A는 위치에 대한 정보이고, C는 명령문으로 먼저 발표할 팀에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 13,
    questionText: "Which menu item is the most popular here?",
    choices: {
      A: "We ordered it last week.",
      B: "The grilled salmon.",
      C: "I'll take your order soon.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이곳에서 가장 인기 있는 메뉴 항목은 무엇인가요?",
      choices: {
        A: "우리는 지난주에 그것을 주문했어요.",
        B: "그릴에 구운 연어요.",
        C: "곧 주문을 받겠습니다.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 가장 인기 있는 메뉴 항목이 그릴에 구운 연어라고 직접적으로 답변하고 있습니다. A는 과거 행동에 대한 설명이고, C는 진행 예고로 인기 있는 메뉴에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 14,
    questionText: "Which product line had the highest sales last month?",
    choices: {
      A: "The electronics category.",
      B: "Last month's results were strong.",
      C: "Please update the spreadsheet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지난달에 어떤 제품 라인이 가장 높은 매출을 기록했나요?",
      choices: {
        A: "전자제품 카테고리요.",
        B: "지난달 결과는 좋았어요.",
        C: "스프레드시트를 업데이트해 주세요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. A는 지난달에 가장 높은 매출을 기록한 제품 라인이 전자제품 카테고리라고 직접적으로 답변하고 있습니다. B는 시간에 대한 일반적인 설명이고, C는 명령문으로 높은 매출을 기록한 제품 라인에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 15,
    questionText: "Which file are we supposed to submit today?",
    choices: {
      A: "It's due at 5 p.m.",
      B: "The revised budget report.",
      C: "I submitted mine already.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 어떤 파일을 제출해야 하나요?",
      choices: {
        A: "오후 5시까지 제출해야 해요.",
        B: "수정된 예산 보고서요.",
        C: "저는 이미 제출했어요.",
      },
    },
    explanation:
      "Which로 시작하는 질문은 특정 대상에 대한 정보를 요구합니다. B는 오늘 제출해야 하는 파일이 수정된 예산 보고서라고 직접적으로 답변하고 있습니다. A는 마감 시간에 대한 정보이고, C는 개인적인 행동에 대한 설명으로 제출해야 하는 파일에 대한 질문에 적절한 답변이 아닙니다.",
  },
  {
    questionNumber: 16,
    questionText: "Should I email the document now, or give you a printout?",
    choices: {
      A: "I reviewed the document.",
      B: "The printer is in the hallway.",
      C: "Please send it as a PDF.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "문서를 지금 이메일로 보내드릴까요, 아니면 인쇄물을 드릴까요?",
      choices: {
        A: "문서를 검토했어요.",
        B: "프린터는 복도에 있어요.",
        C: "PDF로 보내주세요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 옵션 중 하나를 선택하는 질문입니다. C는 이메일로 PDF를 보내달라고 명확하게 선택하고 있습니다. A는 문서 검토에 대한 언급이고, B는 프린터 위치에 대한 정보로, 둘 다 문서 전달 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 17,
    questionText: "Will you attend the seminar in person, or join online?",
    choices: {
      A: "The seminar starts soon.",
      B: "I'll log in remotely.",
      C: "I haven't seen the flyer.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question:
        "세미나에 직접 참석하실 건가요, 아니면 온라인으로 참여하실 건가요?",
      choices: {
        A: "세미나가 곧 시작돼요.",
        B: "원격으로 로그인할게요.",
        C: "전단지를 보지 못했어요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 참석 방식 중 하나를 선택하는 질문입니다. B는 원격으로 로그인하겠다고 명확하게 온라인 참여를 선택하고 있습니다. A는 시간에 대한 언급이고, C는 정보 부족에 대한 설명으로, 둘 다 참석 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 18,
    questionText:
      "Is the presentation happening in the conference room, or in the auditorium?",
    choices: {
      A: "Please arrive early.",
      B: "It's scheduled for the auditorium.",
      C: "The slides look great.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프레젠테이션이 회의실에서 열리나요, 아니면 강당에서 열리나요?",
      choices: {
        A: "일찍 도착해 주세요.",
        B: "강당에서 예정되어 있어요.",
        C: "슬라이드가 훌륭해 보여요.",
      },
    },
    explanation:
      "or로 연결된 두 장소 중 하나를 선택하는 질문입니다. B는 프레젠테이션이 강당에서 열린다고 명확하게 장소를 선택하고 있습니다. A는 도착 시간에 대한 요청이고, C는 슬라이드 품질에 대한 언급으로, 둘 다 장소에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 19,
    questionText: "Should we meet before lunch, or later in the afternoon?",
    choices: {
      A: "I brought lunch today.",
      B: "After 3 p.m. works for me.",
      C: "The room is reserved.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "점심 전에 만날까요, 아니면 오후 늦게 만날까요?",
      choices: {
        A: "오늘 점심을 가져왔어요.",
        B: "오후 3시 이후가 괜찮아요.",
        C: "방이 예약되어 있어요.",
      },
    },
    explanation:
      "or로 연결된 두 시간대 중 하나를 선택하는 질문입니다. B는 오후 3시 이후가 괜찮다고 명확하게 오후 늦은 시간을 선택하고 있습니다. A는 점심에 대한 개인적인 언급이고, C는 방 예약에 대한 정보로, 둘 다 만남 시간에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 20,
    questionText: "Will the client call us, or should we contact them first?",
    choices: {
      A: "They sent the invoice.",
      B: "I wasn't at the meeting.",
      C: "We should reach out right away.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question:
        "고객이 우리에게 전화할까요, 아니면 우리가 먼저 연락해야 할까요?",
      choices: {
        A: "그들이 청구서를 보냈어요.",
        B: "저는 회의에 참석하지 않았어요.",
        C: "우리가 바로 연락해야 해요.",
      },
    },
    explanation:
      "or로 연결된 두 연락 방식 중 하나를 선택하는 질문입니다. C는 우리가 바로 연락해야 한다고 명확하게 선택하고 있습니다. A는 청구서에 대한 정보이고, B는 회의 불참에 대한 개인적인 언급으로, 둘 다 연락 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 21,
    questionText: "Do you prefer the darker color scheme, or the lighter one?",
    choices: {
      A: "The logo needs revision.",
      B: "I prefer the lighter design.",
      C: "I'll email the image.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question:
        "더 어두운 색상 구성을 선호하시나요, 아니면 더 밝은 것을 선호하시나요?",
      choices: {
        A: "로고는 수정이 필요해요.",
        B: "더 밝은 디자인을 선호해요.",
        C: "이미지를 이메일로 보내드릴게요.",
      },
    },
    explanation:
      "or로 연결된 두 색상 구성 중 하나를 선택하는 질문입니다. B는 더 밝은 디자인을 선호한다고 명확하게 선택하고 있습니다. A는 로고 수정에 대한 언급이고, C는 이미지 전송에 대한 제안으로, 둘 다 색상 선호도에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 22,
    questionText: "Is the break scheduled for 2:00, or closer to 3:00?",
    choices: {
      A: "I just stepped out.",
      B: "That's when the meeting ends.",
      C: "It starts at 3:00.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "휴식이 2시로 예정되어 있나요, 아니면 3시에 가깝나요?",
      choices: {
        A: "방금 나갔다 왔어요.",
        B: "그때 회의가 끝나요.",
        C: "3시에 시작해요.",
      },
    },
    explanation:
      "or로 연결된 두 시간 중 하나를 선택하는 질문입니다. C는 휴식이 3시에 시작한다고 명확하게 선택하고 있습니다. A는 개인적인 행동에 대한 언급이고, B는 회의 종료 시간에 대한 정보로, 둘 다 휴식 시간에 대한 명확한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 23,
    questionText:
      "Should I forward the document to legal, or to the finance team?",
    choices: {
      A: "I saved a copy.",
      B: "Send it to finance.",
      C: "It's urgent.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question:
        "문서를 법무팀에 전달해야 할까요, 아니면 재무팀에 전달해야 할까요?",
      choices: {
        A: "사본을 저장했어요.",
        B: "재무팀에 보내세요.",
        C: "긴급해요.",
      },
    },
    explanation:
      "or로 연결된 두 부서 중 하나를 선택하는 질문입니다. B는 재무팀에 보내라고 명확하게 선택하고 있습니다. A는 문서 사본에 대한 언급이고, C는 문서의 긴급성에 대한 정보로, 둘 다 문서를 전달할 부서에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 24,
    questionText:
      "Is the software update automatic, or do we need to install it manually?",
    choices: {
      A: "The screen is frozen.",
      B: "I haven't used it yet.",
      C: "It installs by itself.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question:
        "소프트웨어 업데이트가 자동인가요, 아니면 수동으로 설치해야 하나요?",
      choices: {
        A: "화면이 멈췄어요.",
        B: "아직 사용해보지 않았어요.",
        C: "자동으로 설치돼요.",
      },
    },
    explanation:
      "or로 연결된 두 설치 방식 중 하나를 선택하는 질문입니다. C는 소프트웨어가 자동으로 설치된다고 명확하게 선택하고 있습니다. A는 화면 상태에 대한 언급이고, B는 사용 경험에 대한 개인적인 정보로, 둘 다 업데이트 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 25,
    questionText:
      "Will the package arrive by courier, or should I pick it up myself?",
    choices: {
      A: "We ordered it yesterday.",
      B: "It contains office supplies.",
      C: "A courier will deliver it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "택배로 배송될 예정인가요, 아니면 제가 직접 수령해야 하나요?",
      choices: {
        A: "어제 주문했어요.",
        B: "사무용품이 들어있어요.",
        C: "택배로 배송될 거예요.",
      },
    },
    explanation:
      "or로 연결된 두 배송 방식 중 하나를 선택하는 질문입니다. C는 택배로 배송될 것이라고 명확하게 선택하고 있습니다. A는 주문 시간에 대한 언급이고, B는 패키지 내용물에 대한 정보로, 둘 다 배송 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 26,
    questionText: "Should I email the file to HR or hand it in myself?",
    choices: {
      A: "It's better to submit it in person.",
      B: "HR sent a memo earlier.",
      C: "Tomorrow morning.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "HR에 파일을 이메일로 보내야 할까요, 아니면 직접 제출해야 할까요?",
      choices: {
        A: "직접 제출하는 것이 좋겠어요.",
        B: "HR이 일찍 메모를 보냈어요.",
        C: "내일 아침에요.",
      },
    },
    explanation:
      "or로 연결된 두 제출 방식 중 하나를 선택하는 질문입니다. A는 직접 제출하는 것이 좋다고 명확하게 선택하고 있습니다. B는 HR의 메모에 대한 언급이고, C는 시간에 대한 정보로, 둘 다 파일 제출 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 27,
    questionText: "Would you rather join the video call or attend in person?",
    choices: {
      A: "The meeting starts at 2.",
      B: "I'll just join online.",
      C: "Let's check the agenda.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "화상 통화에 참여하시겠어요, 아니면 직접 참석하시겠어요?",
      choices: {
        A: "회의는 2시에 시작해요.",
        B: "온라인으로 참여할게요.",
        C: "의제를 확인해 봅시다.",
      },
    },
    explanation:
      "or로 연결된 두 참석 방식 중 하나를 선택하는 질문입니다. B는 온라인으로 참여하겠다고 명확하게 선택하고 있습니다. A는 회의 시작 시간에 대한 정보이고, C는 의제 확인에 대한 제안으로, 둘 다 참석 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 28,
    questionText:
      "Should I copy you on the email or just forward the document later?",
    choices: {
      A: "Please include me on the email.",
      B: "That document is outdated.",
      C: "I think he's in a meeting.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "이메일에 당신을 참조로 넣을까요, 아니면 나중에 문서만 전달할까요?",
      choices: {
        A: "이메일에 저를 포함시켜 주세요.",
        B: "그 문서는 오래되었어요.",
        C: "그는 회의 중인 것 같아요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 옵션 중 하나를 선택하는 질문입니다. A는 이메일에 자신을 포함시켜 달라고 명확하게 선택하고 있습니다. B는 문서의 상태에 대한 정보이고, C는 다른 사람의 상황에 대한 언급으로, 둘 다 이메일 처리 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 29,
    questionText: "Are we using the old logo or the new one for this campaign?",
    choices: {
      A: "The old one was approved last week.",
      B: "Marketing will finalize it tomorrow.",
      C: "At the design meeting.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "이 캠페인에 예전 로고를 사용할까요, 아니면 새 로고를 사용할까요?",
      choices: {
        A: "예전 로고가 지난주에 승인되었어요.",
        B: "마케팅팀이 내일 최종 결정할 거예요.",
        C: "디자인 회의에서요.",
      },
    },
    explanation:
      "or로 연결된 두 로고 중 하나를 선택하는 질문입니다. A는 예전 로고가 지난주에 승인되었다고 언급하며 간접적으로 예전 로고를 사용한다는 것을 나타냅니다. B는 미래의 결정에 대한 정보이고, C는 장소에 대한 언급으로, 둘 다 로고 선택에 대한 답변을 제시하지 않습니다.",
  },
  {
    questionNumber: 30,
    questionText: "Should we ship the samples now or wait for confirmation?",
    choices: {
      A: "We're still waiting for approval.",
      B: "The samples are red.",
      C: "On the second shelf.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "샘플을 지금 발송할까요, 아니면 확인을 기다릴까요?",
      choices: {
        A: "아직 승인을 기다리고 있어요.",
        B: "샘플은 빨간색이에요.",
        C: "두 번째 선반에 있어요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 행동 옵션 중 하나를 선택하는 질문입니다. A는 아직 승인을 기다리고 있다고 언급하며 간접적으로 확인을 기다려야 한다는 것을 나타냅니다. B는 샘플의 색상에 대한 정보이고, C는 위치에 대한 언급으로, 둘 다 발송 시기에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 31,
    questionText: "Will you submit the report today or first thing tomorrow?",
    choices: {
      A: "It's already been uploaded.",
      B: "Let's have coffee first.",
      C: "The report is eight pages long.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "보고서를 오늘 제출하실 건가요, 아니면 내일 첫 일정으로 하실 건가요?",
      choices: {
        A: "이미 업로드했어요.",
        B: "먼저 커피를 마셔요.",
        C: "보고서는 8페이지예요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 시간 옵션 중 하나를 선택하는 질문입니다. A는 이미 보고서를 업로드했다고 언급하며 질문의 두 옵션을 모두 넘어선 상황임을 나타냅니다. B는 관련 없는 제안이고, C는 보고서 길이에 대한 정보로, 둘 다 제출 시기에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 32,
    questionText: "Do you want to meet in the lobby or in the café downstairs?",
    choices: {
      A: "Let's meet at the café.",
      B: "I don't drink coffee.",
      C: "The café opens at 9.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "로비에서 만날까요, 아니면 아래층 카페에서 만날까요?",
      choices: {
        A: "카페에서 만나요.",
        B: "저는 커피를 마시지 않아요.",
        C: "카페는 9시에 열어요.",
      },
    },
    explanation:
      "or로 연결된 두 장소 중 하나를 선택하는 질문입니다. A는 카페에서 만나자고 명확하게 선택하고 있습니다. B는 개인적인 선호도에 대한 정보이고, C는 카페 운영 시간에 대한 정보로, 둘 다 만날 장소에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 33,
    questionText:
      "Should I schedule the demo before or after the presentation?",
    choices: {
      A: "The demo room is booked.",
      B: "After the presentation works better.",
      C: "I already sent the slides.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "데모를 프레젠테이션 전에 예약할까요, 아니면 후에 예약할까요?",
      choices: {
        A: "데모룸이 예약되어 있어요.",
        B: "프레젠테이션 후가 더 좋겠어요.",
        C: "이미 슬라이드를 보냈어요.",
      },
    },
    explanation:
      "or로 연결된 두 시간 옵션 중 하나를 선택하는 질문입니다. B는 프레젠테이션 후가 더 좋다고 명확하게 선택하고 있습니다. A는 데모룸 상태에 대한 정보이고, C는 슬라이드 준비 상태에 대한 언급으로, 둘 다 데모 일정에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 34,
    questionText: "Is the printer connected wirelessly or through a USB cable?",
    choices: {
      A: "It's connected via Wi-Fi.",
      B: "That's a new model.",
      C: "Please turn it off.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "프린터가 무선으로 연결되어 있나요, 아니면 USB 케이블로 연결되어 있나요?",
      choices: {
        A: "와이파이로 연결되어 있어요.",
        B: "그것은 새 모델이에요.",
        C: "꺼 주세요.",
      },
    },
    explanation:
      "or로 연결된 두 연결 방식 중 하나를 선택하는 질문입니다. A는 와이파이로 연결되어 있다고 명확하게 무선 연결을 선택하고 있습니다. B는 프린터 모델에 대한 정보이고, C는 프린터 작동에 대한 지시로, 둘 다 연결 방식에 대한 선택을 제시하지 않습니다.",
  },
  {
    questionNumber: 35,
    questionText: "Should we reschedule for next week or cancel entirely?",
    choices: {
      A: "Canceling seems better.",
      B: "I didn't get the invite.",
      C: "At the end of the quarter.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다음 주로 일정을 변경할까요, 아니면 완전히 취소할까요?",
      choices: {
        A: "취소하는 것이 더 좋을 것 같아요.",
        B: "초대를 받지 못했어요.",
        C: "분기 말에요.",
      },
    },
    explanation:
      "or로 연결된 두 가지 옵션 중 하나를 선택하는 질문입니다. A는 취소하는 것이 더 좋을 것 같다고 명확하게 선택하고 있습니다. B는 개인적인 상황에 대한 언급이고, C는 시간에 대한 정보로, 둘 다 일정 처리 방식에 대한 선택을 제시하지 않습니다.",
  },
];
